import React, {useEffect, useState} from 'react';
import ProductRelDocs from "../components/products-rel-docs/prd-main";
import { abtest_ProductListPricingAreaVariants } from "../../../list-page/interfaces/interfaces";
import {rootActions, useAppDispatch, useAppSelector} from "../data-services/store";
import {getABTest_ProductListPricingArea} from "../data-services/data-service";

/**
 * the entry point
 */
const App: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useAppDispatch()
    const productsRelDocsInitialSelected = useAppSelector((store) => store.productsRelDocsInitialSelected);
    const isProductNote = !productsRelDocsInitialSelected.skuEnabled && productsRelDocsInitialSelected.note !== null && productsRelDocsInitialSelected.note !== '';

    /**
     * ABTests
     */
    useEffect(() => {
        (async () => {
            setIsLoading(false);
            const _abtest_ProductListPricingArea = (productsRelDocsInitialSelected.includedInSBS > 0 && !isProductNote) ? getABTest_ProductListPricingArea() : abtest_ProductListPricingAreaVariants.old;
            //console.log('_abtest_ProductListPricingArea: ',_abtest_ProductListPricingArea);
            dispatch(rootActions.main({
                abtest_ProductListPricingArea: _abtest_ProductListPricingArea
            }));

        })();
    }, [dispatch]);


    return (
        <div className="my-4">

            {
                !isLoading  &&
                <>
                    <ProductRelDocs />
                </>
            }

        </div>
    )
};

export default App;